import React, { useState, useEffect } from 'react'
import Toggle from './Toggle'
import {postMortgageRepayment} from '../../Calculators/api';
import {
  allowNumericOnly,
  numberWithCommas,
  numberAddCommas,
  numberClearCommas,
  presenceErrorClass,
} from 'servos/formValidations'

const interestMatrix = I18n.t(`calculators.interest_matrix`);

const onCalculationFailure = (response) => {
  console.log('Invalid loan amount')
}

const TogglesContainer = ({
  isOwnHome,
  isInterestOnly,
  setIsOwnHome,
  setIsInterestOnly,
  setSpecialTypeRepayment,
  setRegularTypeRepayment,
  setPoorTypeRepayment,
  setLeaseDocTypeRepayment,
  setSmsfResidentRepayment,
  specialTypeRate,
  regularTypeRate,
  poorTypeRate,
  leaseDocTypeRate,
  setCardHeader60,
  setCardHeader80,
  setCardHeader90,
}) => {
  const interestType = ['payg_variable', 'regular', 'poor', 'smsf'];
  const [loanAmount, setLoanAmount] = useState('350000');

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getMortgageRepayment();
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [loanAmount, isOwnHome, isInterestOnly, specialTypeRate, regularTypeRate, poorTypeRate, leaseDocTypeRate])

  const getMortgageRepayment = () => {
    const loanType = isOwnHome ? 'live' : 'invest';
    const paymentType = isInterestOnly ? 2 : 0

    const onCalculationSuccess = (response) => {
      const type = response.data.type
      const payment = response.data.monthlyMortgageRepaymentLabel

      if (type === 'payg_variable') {
        setSpecialTypeRepayment(payment)
      } else if (type === 'regular') {
        setRegularTypeRepayment(payment)
      } else if (type === 'lease_doc') {
        setLeaseDocTypeRepayment(payment)
      } else if (type === 'smsf') {
        setSmsfResidentRepayment(payment)
      } else {
        setPoorTypeRepayment(payment)
      }
    }

    if (isInterestOnly) {
      const specialTypeRepayment = Math.round((loanAmount * (specialTypeRate / 100)) / 12)
      const regularTypeRepayment = Math.round((loanAmount * (regularTypeRate / 100)) / 12)
      const poorTypeRepayment = Math.round((loanAmount * (poorTypeRate / 100)) / 12)
      const leaseDocTypeRepayment = Math.round((loanAmount * (leaseDocTypeRate / 100)) / 12)

      setSpecialTypeRepayment('$'+numberAddCommas(specialTypeRepayment))
      setRegularTypeRepayment('$'+numberAddCommas(regularTypeRepayment))
      setPoorTypeRepayment('$'+numberAddCommas(poorTypeRepayment))
      setLeaseDocTypeRepayment('$'+numberAddCommas(leaseDocTypeRepayment))
    } else {
      const types = isOwnHome ? ['payg_variable', 'regular', 'poor'] : interestType

      types.forEach(type => {
        let interest = 0;
        if (type === 'payg_variable') {
          interest = interestMatrix[loanType]['regular'][type][paymentType] / 100
        } else {
          if (interestMatrix[loanType][type]) {
            interest = interestMatrix[loanType][type]['variable'][paymentType] / 100
          }
        }

        const paymentData = {
          "current_loan_amount": loanAmount,
          "current_interest_rate": interest,
          "remaining_loan_term": 30,
          "type": type, 
          "repayment_frequency": "monthly"
        }
        postMortgageRepayment({ "mortgage_repay": paymentData }, onCalculationSuccess, onCalculationFailure)
      })
    }
  }

  useEffect(() => {
    if (isOwnHome) {
      setCardHeader60('Low rate home loan');
      setCardHeader80('Offset home loan');
      setCardHeader90('Low doc home loan');
  
      if (!isInterestOnly) {
        setCardHeader60('Low rate home loan');
        setCardHeader80('Offset home loan');
        setCardHeader90('Low doc home loan');
      } else {
        setCardHeader60('SMSF commercial loan');
        setCardHeader80('Commercial loan');
        setCardHeader90('Low doc commercial loan');
      }
    } else {
      if (!isInterestOnly) {
        setCardHeader60('Low rate investor loan');
        setCardHeader80('Offset investor loan');
        setCardHeader90('Low doc investor loan');
      } else {
        setCardHeader60('SMSF commercial loan');
        setCardHeader80('Commercial loan');
        setCardHeader90('Low doc commercial loan');
      }
    }
  }, [isOwnHome, isInterestOnly]); 

  const handleClick = (e) => {
    switch(e.target.id) {
      case 'own':
        setIsOwnHome(true)
        break;
      case 'invest':
        setIsOwnHome(false)
        break;
      case 'residential':
        setIsInterestOnly(false)
        break;
      case 'commercial':
        setIsInterestOnly(true)
        setIsOwnHome(false)

        break;
    }
  }

  function handleKeyPress(e) {
    setSpecialTypeRepayment('$...')
    setRegularTypeRepayment('$...')
    setPoorTypeRepayment('$...')
  }

  const input = document.querySelector('#loan-amount')
  if (input) {
    input.addEventListener('keypress', handleKeyPress);
  }

  return (
    <div className="row justify-content-around">
      <div className="col-lg-4 col-md-12 col-sm-12 mt-3">
        <div className='toggle-container'>
          <div className="toggle-label">
            <h2 className="text-center">Loan Amount</h2>
          </div>
          <div className="toggle-form ml-2">
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">$</div>
              </div>
              <input
                id='loan-amount'
                value={ numberAddCommas(loanAmount) }
                onKeyPress={ allowNumericOnly }
                onKeyUp={ numberWithCommas }
                className="form-control form-control-lg"
                inputMode='numeric'
                onChange={(e) => setLoanAmount(numberClearCommas(e.target.value))}
              />
            </div>
            <span>Over a 30 year loan term</span>
          </div>
        </div>
      </div>
      <Toggle
        id1='own'
        id2='invest'
        header='Loan Objective'
        text1='Live in'
        text2='Invest in'
        onClick={handleClick}
        toggleButtonTheme1={isOwnHome ? 'active' : ''}
        toggleButtonTheme2={isOwnHome ? '' : 'active'}
      />
      <Toggle
        id1='residential'
        id2='commercial'
        header='Property Type'
        text1='Residential'
        text2='Commercial'
        onClick={handleClick}
        toggleButtonTheme1='active'
      />
    </div>
  );
};

export default TogglesContainer;
